import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import type { Props } from '@/types/cms/magnolia';
import classNames from 'classnames';
import { checkPathCompatibility } from '@/Util/globals';

const DefaultPageLayout: FC<PropsWithChildren<{ pageProps: Props }>> = ({
  children,
  pageProps
}) => {
  const { magnoliaContext, siteConfig } = pageProps;

  return (
    <>
      <div
        className={classNames('page__center__wrapper', {
          'page__center__wrapper--website-search':
            !!magnoliaContext.nodePath &&
            checkPathCompatibility(
              magnoliaContext.nodePath,
              siteConfig.parameters.websiteSearchPage
            )
        })}
      >
        {children}
      </div>
    </>
  );
};

export default DefaultPageLayout;
